<template>
  <div>
    {{total | currency}} paid for
    {{count | formatCount('piece')}}

    <div v-if="items && items.length === count && total !== sumTotal" class="text-danger">
      {{sumTotal | currency}} sum does not match
    </div>
  </div>
</template>

<script>
import { sumBy } from 'lodash'

import { currency } from '@/utils/currency.js'

export default {
  name: 'ArtUsagesSummary',
  components: {},
  filters: {
    currency,
  },
  props: {
    total: Number,
    items: Array,
    count: Number,
  },
  computed: {
    sumTotal() {
      return sumBy(this.items, 'amount_due') / 100
    },
  },
}
</script>
